import {
  ID,
  noGroupingId,
  ReorderItem,
  ReorderResult,
  TaskListItemTypes,
} from '@griply/types';

import { filterNewTaskChildIds } from './filter-new-task-child-ids';

export type OnSectionReorderOptions = {
  updatedItems: readonly ReorderItem[];
  hasSections: boolean;
  rootSectionId: ID;
};

export const onSectionReorder = ({
  updatedItems,
  hasSections,
  rootSectionId,
}: OnSectionReorderOptions): ReorderResult => {
  const updatedSections: ReorderResult['updatedSections'] = [];

  updatedItems.forEach((item) => {
    if (item.type === TaskListItemTypes.Section) {
      updatedSections.push({
        id: item.id,
        taskSorting: filterNewTaskChildIds(item.children),
      });
      return;
    }

    if (item.type === TaskListItemTypes.Root) {
      updatedSections.push({
        id: hasSections ? rootSectionId : noGroupingId,
        taskSorting: filterNewTaskChildIds(item.children),
      });
    }
  });

  return { updatedSections, updatedTasks: [] };
};
